export interface ICommand { }

export class CreateCostSubtotalCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.CreateCostSubtotalCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.CreateCostSubtotalCommandV1, TCh.Domain.Quest'
	}

}

export class CreateExpenseAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.CreateExpenseAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	Classification: any
	SubtotalId: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, classification: any, subtotalId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.Classification = classification
		this.SubtotalId = subtotalId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.CreateExpenseAccountCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteCostSubtotalCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.DeleteCostSubtotalCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.DeleteCostSubtotalCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteExpenseAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.DeleteExpenseAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.DeleteExpenseAccountCommandV1, TCh.Domain.Quest'
	}

}

export class RenameCostSubtotalCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.RenameCostSubtotalCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.RenameCostSubtotalCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCostAccountClassificationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountClassificationCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Classification: any

	constructor (workspaceId: number, strategyId: string, id: string, classification: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Classification = classification
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountClassificationCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCostAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	SubtotalId: string
	Classification: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, subtotalId: string, classification: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.SubtotalId = subtotalId
		this.Classification = classification
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCostAccountParentCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountParentCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	SubtotalId: string

	constructor (workspaceId: number, strategyId: string, id: string, subtotalId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.SubtotalId = subtotalId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Costs.Commands.UpdateCostAccountParentCommandV1, TCh.Domain.Quest'
	}

}

